import React from 'react';
import { SAMSFleetSizeSlider } from '../common/SliderControls/SliderControls';
import type { RegistryComponentProps } from '../../pages/registry/componentRegistry';
import { getRegistryData } from '../../pages/registry/componentRegistry';
import { useFormContextOptional } from '../../contexts/FormContext';

const SLUG = 'fleet-size';

interface FleetSizeData {
  samsFleetSize?: number;
  dbSamsFleetSize?: number;
  updatingParams?: boolean;
}

export default function FleetSize(props: RegistryComponentProps): React.ReactElement {
  const formContext = useFormContextOptional();
  const data = getRegistryData<FleetSizeData>(props);

  const dbSamsFleetSize = data.dbSamsFleetSize ?? 300;
  const formValue = formContext?.values?.[SLUG] as number | undefined;
  const samsFleetSize = formValue ?? data.samsFleetSize ?? dbSamsFleetSize ?? 300;

  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = parseInt(e.target.value, 10);
      formContext?.setValue(SLUG, newValue);
    },
    [formContext]
  );

  return (
    <SAMSFleetSizeSlider
      samsFleetSize={samsFleetSize}
      dbSamsFleetSize={dbSamsFleetSize}
      handleFleetSizeChange={handleChange}
      updatingParams={data.updatingParams ?? false}
    />
  );
}
